
export const faqs = [
    {
      question: "What is physical therapy?",
      answer: "Physical therapy is a healthcare specialty focused on diagnosing, treating, and managing conditions that affect movement, function, and physical well-being. It uses exercises, manual therapy, and various techniques to promote recovery and improve mobility."
    },
    {
      question: "How do I know if physiotherapy will help me?",
      answer: "Physiotherapy can benefit anyone experiencing pain, reduced mobility, or recovering from an injury. A physiotherapist will assess your condition and create a personalized treatment plan to help you recover and regain strength."
    },
    {
      question: "Can I go to any physiotherapy I choose?",
      answer: "In most cases, you can choose the physiotherapy clinic you prefer. However, it’s always a good idea to check with your insurance provider to ensure they cover the clinic you want to visit."
    },
    {
      question: "How do I schedule an appointment?",
      answer: "You can schedule an appointment by calling our clinic, visiting our website, or using our online booking system. We’ll work with you to find a convenient time for your first session."
    },
  

    {
      question: "Does insurance cover my treatment?",
      answer: "Many insurance plans cover physiotherapy treatments, but coverage varies. We recommend checking with your provider to confirm your benefits before starting treatment."
    },
    // {
    //   question: "What if I don’t have insurance?",
    //   answer: "If you don’t have insurance, we offer competitive self-pay rates and payment plans to help make your treatment more affordable. Contact us to learn more about our options."
    // },
    // {
    //   question: "What type of payment do you accept?",
    //   answer: "We accept a variety of payment methods including credit cards, debit cards, checks, and cash. We also offer flexible payment plans if needed."
    // },
    // {
    //   question: "What do I wear?",
    //   answer: "Wear comfortable, loose-fitting clothing that allows for movement. Depending on your treatment, you may need to expose certain areas of your body, so shorts and a t-shirt or tank top are often recommended."
    // },
    // {
    //   question: "How long will my therapy sessions last?",
    //   answer: "Therapy sessions typically last between 30 to 60 minutes, depending on your treatment plan and specific needs."
    // },
    // {
    //   question: "How many sessions will I have?",
    //   answer: "The number of sessions varies based on your condition, treatment goals, and progress. Your therapist will assess your situation and recommend a treatment plan that may range from a few sessions to several weeks."
    // },
    // {
    //   question: "What types of education/training do your therapists have?",
    //   answer: "Our therapists are highly trained professionals with advanced degrees in physiotherapy. They are licensed and continue to pursue ongoing education to stay up-to-date with the latest techniques and treatments."
    // },
    // {
    //   question: "Do you offer programs for me once I’m better?",
    //   answer: "Yes, we offer post-rehabilitation programs to help maintain and further improve your physical health. These programs are tailored to your needs and designed to prevent future injuries."
    // }
  ];
